import BaseMetricCard, {
  MetricCardConfig,
} from "../../../Common/BaseMetricCard";
import { WellnessScoreStatus } from "../../../Common/types";
import { isNativeApp } from "@/utils";

export interface BloodPressureCardProps {
  metricValue: string;
  status: WellnessScoreStatus;
  lastUpdated?: string;
  onManualEntryClick?: () => void;
}

const MANUAL_ENTRY_ROUTE = "/home/health-score/blood-pressure-manual-entry";

const config: MetricCardConfig = {
  translationPrefix: "BloodPressure",
  analyticsSource: "Health Score - blood pressure",
  manualEntryRoute: MANUAL_ENTRY_ROUTE,
  ctaRoute: isNativeApp() ? MANUAL_ENTRY_ROUTE : undefined,
};

export default function BloodPressureCard(props: BloodPressureCardProps) {
  return <BaseMetricCard {...props} config={config} />;
}
